/* eslint-disable indent */
/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import urlJoin from 'url-join'

import {graphql, StaticQuery} from 'gatsby'
import icon from '../images/favicon.png'

const Seo = ({description, metaImage, author, routeUrl, title}) => (
	<StaticQuery query={graphql`
		{
		  seo: file(relativePath: {eq: "global/seo.json"}) {
			childGlobalJson {
				  language
				  titlePostfix
				  siteUrl
			}
		  }
		}
	`}>{(data) => {
		const {titlePostfix, language, siteUrl} = data.seo.childGlobalJson
		return <Helmet
			htmlAttributes={{
				lang: language,
			}}
			link={[
				{rel: 'icon', type: 'image/png', sizes: '16x16', href: `${icon}`},
			]}
			title={title}
			titleTemplate={`%s${titlePostfix}`}
			meta={[
				{name: 'description', content: description},
				{property: 'og:title', content: title},
				{property: 'og:description', content: description},
				{property: 'og:type', content: 'website'},
				{property: 'og:image', content: metaImage.publicURL},
				{property: 'og:url', content: urlJoin(siteUrl, routeUrl)},
				{name: 'twitter:card', content: 'summary'},
				{name: 'twitter:creator', content: author},
				{name: 'twitter:title', content: title},
				{name: 'twitter:image', content: metaImage.publicURL},
				{name: 'twitter:description', content: description},
			]}/>
	}}</StaticQuery>
)

Seo.defaultProps = {
	description: undefined,
	image: undefined,
}

Seo.propTypes = {
	routeUrl: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	metaImage: PropTypes.shape({
		publicURL: PropTypes.string,
	}),
}

export default Seo
